import { env } from '@/env'

import type { MaintenanceState } from '../types'

/**
 * Lê o estado da manutenção no endpoint público — sem token de propósito, para
 * que um aluno deslogado também consiga ver a tela de manutenção.
 *
 * Usa `fetch` direto em vez do cliente `api`: o interceptor dele chama
 * `getSession()` a cada requisição, e este guard roda em toda navegação para
 * dentro da área do aluno — seria uma busca de sessão extra por clique, para um
 * endpoint que não olha o token.
 *
 * Falha de leitura NÃO bloqueia: se a api estiver fora do ar, trancar a área do
 * aluno transformaria uma indisponibilidade em duas. Na dúvida, libera.
 */
export async function fetchMaintenanceState(): Promise<MaintenanceState | null> {
  try {
    const response = await fetch(
      `${env.NEXT_PUBLIC_PGEE_API_BASE_URL}/public/configurations`,
      { headers: { accept: 'application/json' }, cache: 'no-store' }
    )

    if (!response.ok) return null

    const body = await response.json()
    return (body?.record?.maintenance as MaintenanceState) ?? null
  } catch {
    return null
  }
}
